var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"dashboard-bar-line header-solid",attrs:{"bordered":false}},[_c('div',{staticClass:"title_box"},[_vm._v("使用趋势")]),_c('div',{staticStyle:{"width":"100%","height":"385px"},attrs:{"id":"demo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }